export default {
    fileUpload: {
        clickToUpload: "Clicca per caricare",
        andAttachFiles: "e allega file",
        orDragAndDrop: "oppure trascina e rilascia",
        defaultHint: "SVG, PNG, JPG o GIF (max. 800x400px)",
        complete: "Completato",
        uploading: "Caricamento in corso...",
        failed: "Fallito",
        delete: "Elimina",
        retry: "Riprova",
        tryAgain: "Riprova",
        uploadFailed: "Caricamento fallito, riprova",
        dragAndDrop: "o trascina e rilascia",
        maxFileSize: "Dimensione massima: {{size}}",
        acceptedFormats: "Formati accettati: {{formats}}",
        uploadSuccess: "File caricato con successo",
        uploadError: "Errore nel caricamento del file",
    },
    commandMenu: {
        title: "Menu Comandi",
        searchPlaceholder: "Cerca...",
        removeFilter: "Rimuovi filtro",
        noResults: "Nessun risultato trovato",
        startTyping: "Inizia a digitare per cercare...",
        entities: {
            container: "Container",
            sender: "Mittente",
            receiver: "Ricevente",
            account: "Account",
            address: "Rubrica",
            document: "Documenti",
        },
    },
    aiChat: {
        title: "Chat AI",
        placeholder: "Chiedi all'AI…",
        ariaLabel: "Chat AI",
        welcome: "Ciao, come posso aiutarti?",
        welcomeSubtitle: "Scegli un'azione per iniziare",
        actions: {
            createContainer: "Crea Container",
            createOrder: "Crea Ordine",
            createQuoteRequest: "Crea Richiesta Preventivo",
            createQuote: "Crea Preventivo",
        },
        you: "Tu",
        assistant: "Assistente",
        attach: "Allega",
        emoji: "Emoji",
        newChat: "Nuova chat",
        chatHistory: "Cronologia chat",
        noChats: "Nessuna chat ancora",
        deleteChat: "Elimina chat",
        confirmDelete: "Sei sicuro di voler eliminare questa chat?",
        renameChat: "Rinomina chat",
        chatTitle: "Titolo chat",
        saveTitle: "Salva titolo",
        editTitle: "Modifica titolo",
        wizard: {
            confirmed: "Perfetto! Continuiamo...",
            enterValue: "Inserisci il valore...",
            create: "Crea",
            cancelled: "Wizard annullato. Come posso aiutarti?",
            notSpecified: "Non specificato",
            container: {
                containerNumber: "Qual è il numero del container?",
                routeFrom: "Da quale città parte il container?",
                routeTo: "Verso quale città va il container?",
                eta: "Qual è la data di arrivo prevista (ETA)?",
                valueAmount: "Qual è il valore del container?",
                valueCurrency: "Quale valuta vuoi usare?",
                status: "Qual è lo stato del container?",
                receiverId: "Quale receiver vuoi selezionare?",
                shippingCompany: "Quale compagnia di shipping? (opzionale)",
                review: "Riepilogo:\n- Numero Container: {{containerNumber}}\n- Da: {{routeFrom}}\n- A: {{routeTo}}\n- ETA: {{eta}}\n- Valore: {{valueAmount}} {{valueCurrency}}\n- Stato: {{status}}\n- Receiver: {{receiver}}\n- Compagnia Shipping: {{shippingCompany}}",
                success: "Container creato con successo!",
                completed: "Container creato! Reindirizzamento...",
            },
            order: {
                shipperId: "Quale shipper vuoi selezionare?",
                targetDate: "Qual è la data target per l'ordine?",
                packingListRequested: "Quali dettagli vuoi nella packing list?",
                notes: "Note aggiuntive (opzionale):",
                review: "Riepilogo:\n- Shipper: {{shipper}}\n- Data Target: {{targetDate}}\n- Packing List: {{packingList}}\n- Note: {{notes}}",
                success: "Ordine creato con successo!",
                completed: "Ordine creato! Reindirizzamento...",
            },
            quoteRequest: {
                subject: "Qual è l'oggetto della richiesta di preventivo?",
                body: "Inserisci il testo della richiesta di preventivo:",
                recipients: "Seleziona i freight forwarder destinatari:",
                review: "Riepilogo:\n- Oggetto: {{subject}}\n- Corpo: {{body}}\n- Destinatari: {{recipients}}",
                success: "Richiesta di preventivo creata con successo!",
                completed: "Richiesta creata! Reindirizzamento...",
            },
            quoteResponse: {
                selectQuote: "A quale richiesta di preventivo vuoi rispondere?",
                usingContext: "Sto rispondendo alla richiesta: {{subject}}",
                responseSubject: "Qual è l'oggetto della risposta?",
                responseBody: "Inserisci il testo della risposta:",
                review: "Riepilogo:\n- Richiesta: {{quoteSubject}}\n- Oggetto Risposta: {{responseSubject}}\n- Corpo Risposta: {{responseBody}}",
                success: "Preventivo creato con successo!",
                completed: "Preventivo creato! Reindirizzamento...",
            },
        },
    },
    stats: {
        vsLastMonth: "vs mese scorso",
    },
    buttons: {
        submit: "Invia",
        cancel: "Annulla",
        save: "Salva",
        delete: "Elimina",
        edit: "Modifica",
        create: "Crea",
        update: "Aggiorna",
        add: "Aggiungi",
        remove: "Rimuovi",
        close: "Chiudi",
        back: "Indietro",
        next: "Avanti",
        previous: "Precedente",
        confirm: "Conferma",
        logout: "Esci",
        login: "Accedi",
        reset: "Reimposta",
        search: "Cerca",
        filter: "Filtra",
        clear: "Pulisci",
        apply: "Applica",
        upload: "Carica",
        download: "Scarica",
        view: "Visualizza",
        share: "Condividi",
        send: "Invia",
        invite: "Invita",
        accept: "Accetta",
        reject: "Rifiuta",
    },
    form: {
        required: "Campo obbligatorio",
        optional: "Opzionale",
        invalid: "Valore non valido",
        emailInvalid: "Indirizzo email non valido",
        passwordTooShort: "La password deve essere di almeno 8 caratteri",
        selectPlaceholder: "Seleziona un'opzione...",
        searchPlaceholder: "Cerca...",
        noResults: "Nessun risultato trovato",
        loading: "Caricamento...",
        errors: {
            allFieldsRequired: "Tutti i campi sono obbligatori",
            amountInvalid: "L'importo deve essere un numero maggiore di 0",
        },
    },
    validation: {
        required: "Questo campo è obbligatorio",
        email: "Inserisci un indirizzo email valido",
        minLength: "Deve essere di almeno {{count}} caratteri",
        maxLength: "Deve essere di massimo {{count}} caratteri",
        pattern: "Formato non valido",
    },
    errors: {
        generic: "Si è verificato un errore",
        network: "Errore di rete. Riprova.",
        unauthorized: "Accesso non autorizzato",
        notFound: "Risorsa non trovata",
        serverError: "Errore del server. Riprova più tardi.",
        unknown: "Errore sconosciuto",
    },
    messages: {
        success: "Operazione completata con successo",
        saved: "Salvato con successo",
        deleted: "Eliminato con successo",
        created: "Creato con successo",
        updated: "Aggiornato con successo",
        loading: "Caricamento...",
        noData: "Nessun dato disponibile",
        confirmDelete: "Sei sicuro di voler eliminare questo elemento?",
    },
    date: {
        today: "Oggi",
        yesterday: "Ieri",
        tomorrow: "Domani",
        thisWeek: "Questa settimana",
        thisMonth: "Questo mese",
        thisYear: "Quest'anno",
    },
    language: "Lingua",
    changeLanguage: "Cambia lingua",
    english: "English",
    italiano: "Italiano",
    pdfViewer: {
        prev: "Prec",
        next: "Succ",
        page: "Pagina",
        addRectangle: "Aggiungi Rettangolo",
        addRectangleHere: "Aggiungi rettangolo qui",
        loadingPdf: "Caricamento PDF...",
    },
    signOut: {
        confirm: {
            title: "Conferma disconnessione",
            message: "Sei sicuro di voler uscire? Dovrai effettuare nuovamente l'accesso per utilizzare l'applicazione.",
        },
    },
    accountSwitch: {
        switching: "Cambio account in corso...",
    },
    orderAccept: {
        confirmCreateQuotes: {
            title: "Crea richieste di preventivo",
            message: "Vuoi creare automaticamente le richieste di preventivo basate sulle specifiche di questo ordine?",
            createQuotes: "Sì, crea le richieste",
            acceptOnly: "No, accetta solo l'ordine",
        },
        creatingQuotes: "Creando le richieste di preventivo",
    },
    theme: "Tema",
    themeLight: "Chiaro",
    themeDark: "Scuro",
    themeSystem: "Sistema",
};
